export default __webpack_public_path__ + "static/media/filter_list-24px.f63786c6.svg";